import { InformationCircleIcon } from "@heroicons/react/16/solid";
import { IconDoubleTag, IconLoading } from "../../assets/icons";

const CardSubscription = ({
  plan,
  title,
  price,
  originalPrice,
  icon: Icon,
  features = [],
  buttonText,
  isCurrentPlan = false,
  highlight = false,
  onClick,
  currentSubscription,
  onCancel,
  expiryTimestamp,
  loading,
  loadingCancel,
}) => {
  const isTrialing = currentSubscription?.metadata?.type === "free_trial";

  const currentAmount =
    currentSubscription?.items?.data?.[0]?.plan?.amount || 0;

  const isDowngrade = plan.unit_amount < currentAmount;

  const isBlockedDowngrade =
    isDowngrade && !currentSubscription?.cancel_at_period_end && !isTrialing;

  return (
    <div
      className={`relative h-[unset] bg-white border rounded-xl  xl:min-w-[400px] ${
        highlight &&
        "max-xl:mt-[3rem] shadow-[0px_16px_32px_-8px_rgba(12,12,13,0.15)]"
      }`}
    >
      {highlight && (
        <span className="w-full text-base font-semibold rounded-xl py-3 pb-6 flex justify-center items-center absolute uppercase text-white px-3 border bg-[linear-gradient(102deg,#007A78_14.66%,#1A4E4D_85.53%)] bottom-[calc(100%-1rem)]">
          <IconDoubleTag className="w-[24px] h-[24px] mr-2" />
          Best Deal
        </span>
      )}
      <div className="bg-white rounded-xl p-6 pb-8 pt-4 flex flex-col items-center text-center relative">
        <div className="flex items-center justify-between w-full">
          <h3 className="text-xl font-semibold">{title}</h3>
          {Icon && <Icon className="w-[50px] h-[50px]" />}
        </div>

        <div className="flex flex-col items-start w-full">
          <p className="text-4xl font-bold m-0 text-[#302571]">{price}</p>
          {originalPrice && (
            <p className="text-base font-semibold text-[#D9D9D9] line-through m-0 mt-2">
              {originalPrice}
            </p>
          )}
        </div>

        <div className="w-full">
          <button
            disabled={
              isCurrentPlan ||
              loading ||
              (plan.unit_amount < currentSubscription?.plan?.amount &&
                !currentSubscription?.cancel_at_period_end)
            }
            onClick={onClick}
            className={`w-full ${
              isCurrentPlan
                ? "bg-[#DDE1E6] text-[#0003]"
                : "bg-[#302571] text-white"
            } text-base font-medium px-6 py-3 rounded-[10px] mt-4`}
          >
            {isCurrentPlan ? "Your Plan" : buttonText}
          </button>

          {isBlockedDowngrade && (
            <span className="text-sm font-semibold text-[#ff0000] md:max-w-[20rem] mx-auto w-full text-center mt-3 block">
              You must cancel your current subscription before downgrading.
            </span>
          )}

          {isCurrentPlan &&
            // plan.product_id !== "prod_SYxraiwTwCuhPz" &&
            plan.product_id !== "prod_TuS6EvOX9dk0Zx" &&
            (currentSubscription?.cancel_at_period_end ? null : (
              <button
                key={plan.product_id}
                onClick={onCancel}
                disabled={loadingCancel || loading}
                className={`w-full bg-[#ff0000] text-[white] text-base font-medium px-6 py-3 rounded-[10px] mt-4`}
              >
                {loadingCancel ? (
                  <div className="animate-spin w-fit flex justify-center items-center mx-auto">
                    <IconLoading className="w-[24px] h-[24px]" />
                  </div>
                ) : (
                  "Cancel Subscription"
                )}
              </button>
            ))}
          {isCurrentPlan &&
            // plan.product_id !== "prod_SYxraiwTwCuhPz" &&
            plan.product_id !== "prod_TuS6EvOX9dk0Zx" &&
            expiryTimestamp && (
              <div className="bg-[rgba(255,204,0,0.15)] gap-3 p-3 rounded-xl border border-[#FFCC00] flex items-center mt-4">
                <InformationCircleIcon className="w-full max-w-[16px] h-[16px] text-[#8F7303]" />
                <span className=" text-sm">
                  <span className="font-semibold">
                    {isCurrentPlan &&
                      // plan.product_id !== "prod_SYxraiwTwCuhPz" &&
                      plan.product_id !== "prod_TuS6EvOX9dk0Zx" &&
                      currentSubscription?.cancel_at_period_end &&
                      "Subscription Canceled. "}
                  </span>
                  Current period ends on:{" "}
                  {new Date(expiryTimestamp * 1000).toLocaleDateString(
                    "en-GB",
                    {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    },
                  )}
                </span>
              </div>
            )}
        </div>

        {features.length > 0 && (
          <div className="mt-6 w-full text-left">
            <span className="block">With this plan, you can run up to:</span>
            <ul className="mt-2 space-y-2 text-sm text-gray-800 list-disc pl-4">
              {features.map((feature, idx) => (
                <li key={idx}>{feature}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default CardSubscription;
